module.exports = __webpack_public_path__ + "img/Logo_3xOney_RGB_verde.d56b0026.svg";